module.exports = __webpack_public_path__ + "media/images/flags/32/Guinea-Bissau-8f836c08e1c45600061d54907760642d.png";